<template>
  <UApp :toaster="toaster">
    <div class="h-screen flex flex-col bg-[#0F172B] overflow-hidden">
      <!-- 顶部导航：吸顶固定 -->
      <div class="sticky top-0 z-9999">
        <TopBanners />
        <FotoHeader
          :is-index="true"
          redirect-after-login="/ai/effects/"
        />
      </div>

      <!-- 主体：下方左侧为导航，右侧为内容+脚部（右侧单独滚动） -->
      <!-- overflow-hidden：约束 flex 子项高度，否则子级会被内容撑高，右侧 overflow-y-auto 无法滚动 -->
      <div class="flex flex-1 min-h-0 overflow-hidden">
        <!-- 左侧导航：吸附在 Header 下方，占满剩余高度，可单独滚动 -->
        <!-- <ToolAside /> -->

        <!-- 右侧内容区：用 flex-1 占满 Header/Banner 下方剩余高度，勿写死 100vh-60px（Banner 会占位） -->
        <div
          class="flex-1 min-h-0 flex flex-col overflow-y-auto overflow-x-hidden touch-pan-y right-scroll"
        >
          <!-- 内容区域：自然流动，不强制高度 -->
          <NuxtPage keep-alive :keep-alive-props="{ include: includeArr }" />
        </div>
      </div>
    </div>

    <!-- 认证模态框 -->
    <SignUpModal
      :is-open="isSignUpModalOpen"
      @close="closeSignUpModal"
      @switch-to-sign-in="switchToSignIn"
    />
    <SignInModal
      :is-open="isSignInModalOpen"
      @close="closeSignInModal"
      @switch-to-sign-up="switchToSignUp"
    />

    <!-- 积分弹窗 -->
    <NotEnoughCredits
      v-model:is-open="isCreditsModalOpen"
      :required-credits="requiredCredits"
      :current-balance="currentCredits"
      :show-required-credits="showRequiredCredits"
      :view="creditsModalView"
      @close="closeCreditsModal"
    />

    <GlobalImagePreview
      :is-open="isImagePreviewOpen"
      :src="imagePreviewSrc"
      :compare="imagePreviewCompare"
      @close="closeImagePreview"
    />
  </UApp>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import ToolAside from "@/components/ToolAsideNew.vue";
import defaultCssUrl from "~/assets/styles/new-index.css?url";
import FotoHeader from "@/components/FotoHeaderNew.vue";
import FotoFooter from "@/components/FotoFooterNew.vue";
import SignUpModal from "@/components/loginModal/SignUpModal.vue";
import SignInModal from "@/components/loginModal/SignInModal.vue";
import NotEnoughCredits from "@/components/newModal/NotEnoughCredits.vue";
import GlobalImagePreview from "@/components/newModal/GlobalImagePreview.vue";

const toaster = { position: "top-right" };
useHead({
  link: [
    {
      rel: "stylesheet",
      href: defaultCssUrl,
      crossorigin: "anonymous",
      key: "layout-style",
    },
  ],
  htmlAttrs: { class: "dark" }, // 确保 SSR 也加上 dark
});

defineOptions({
  name: "sign-new-layout",
});

const includeArr = ref(["incredible-quality"]);

const store = useStore();

// 获取用户信息和积分
const userInfo = computed(() => store.state.user.userInfo);
const currentCredits = computed(() => userInfo.value?.credits_sum || 0);

// 使用认证模态框 composable
const {
  isSignInModalOpen,
  isSignUpModalOpen,
  closeSignInModal,
  closeSignUpModal,
  switchToSignIn,
  switchToSignUp,
} = useAuthModals();

// 使用积分弹窗 composable
const {
  isCreditsModalOpen,
  requiredCredits,
  showRequiredCredits,
  creditsModalView,
  closeCreditsModal,
} = useCreditsModal();

const {
  isImagePreviewOpen,
  imagePreviewSrc,
  imagePreviewCompare,
  closeImagePreview,
} = useImagePreview();
</script>
